import awsRumActionNames from '../../consts/aws/awsRumActionNames';
import rumCustomEvents from '../../services/events/rumCustomEvents';
import {twx} from '../../utils/tailwindUtils';

const AiAssistantToggle = ({onClick, isActive}) => {
    const onClickHandler = () => {
        rumCustomEvents.recordActionClick({
            rumActionName: isActive ? awsRumActionNames.OFF : awsRumActionNames.ON,
        });

        onClick(!isActive);
    };

    return (
        <div
            onClick={onClickHandler}
            className={twx(
                // 300ms on purpose - slower than the widget's 200ms
                'flex h-7 w-12 shrink-0 cursor-pointer rounded-2xl p-[2px]',
                'transition-colors duration-300 ease-in-out',
                isActive ? 'bg-color-romance' : 'bg-[#2A2A2B]'
            )}
        >
            <div
                className={twx(
                    // Colour in the same transition as the slide, or it snaps on the first frame
                    'h-6 w-6 rounded-full transition-[transform,background-color] duration-300 ease-in-out',
                    isActive ? 'translate-x-5 bg-[#2A2A2B]' : 'bg-color-romance'
                )}
            />
        </div>
    );
};

export default AiAssistantToggle;
